const HOME = "Home"
const MY_PODCASTS = "My Podcasts"
const EPISODES = "Episodes"
const RECORDINGS = "Recordings"
const GUEST_PORTAL = "Guest Portal"
const CALENDAR = "Calendar"
const ANALYTICS = "Analytics"

export { HOME, MY_PODCASTS, EPISODES, RECORDINGS, GUEST_PORTAL, CALENDAR, ANALYTICS }
